import { Root as DialogRoot, type DialogProps } from "@radix-ui/react-dialog";

import { DialogContentActions } from "./actions/actions";
import { DialogContentBody } from "./body/body";
import { DialogContentActionsClose } from "./close/close";
import { DialogContent } from "./content/content";
import { DialogContentHeader } from "./header/header";
import { DialogTrigger } from "./trigger/trigger";

const DialogWithSubcomponents = Object.assign(DialogRoot, {
    Trigger: DialogTrigger,
    Content: Object.assign(DialogContent, {
        Header: DialogContentHeader,
        Body: DialogContentBody,
        Actions: Object.assign(DialogContentActions, {
            Close: DialogContentActionsClose,
        }),
    }),
});

export { DialogWithSubcomponents as Dialog, DialogRoot };

export type { DialogProps };
export * from "./trigger/trigger";
export * from "./content/content";
export * from "./header/header";
export * from "./body/body";
export * from "./actions/actions";
export * from "./close/close";
